import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import themeColors from '../../assets/styles/themeColors';
import TrustNameForm from '../../components/Forms/TrustNameForm';
import { HeadingSubtitle } from '../../components/Heading';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import Paragraph from '../../components/Paragraph/Paragraph';
import { useMenu } from '../../hooks/useMenu';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import { APPLICANT_TYPES } from '../../util/constants';

const SecureAccountTrustName = () => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const { BrokerName } = useSelector(selectSettings);
  const formId = 'trustName_form';
  const [eventType, setEventType] = useState(null);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
      formId={formId}
      setEventType={setEventType}
    >
      <Helmet>
        <title>
          {t('titleTagTrustName', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <HeadingSubtitle mb={12} color={themeColors.colorTextSecondary}>
        {t('secureTrustName.title')}
      </HeadingSubtitle>
      <Paragraph mb={32} color={themeColors.colorTextXLLight}>
        {t('secureTrustName.subtitle')}
      </Paragraph>
      <TrustNameForm
        applicantType={APPLICANT_TYPES.BUSINESS}
        nextPath={activeItem?.nextPath}
        formId={formId}
        setEventType={setEventType}
        eventType={eventType}
      />
    </OnBoardingContainer>
  );
};

export default SecureAccountTrustName;
